import React from 'react';

const CATEGORY_META = {
  ai_accessibility:    { label: 'AI Accessibility',    icon: '🤖', weight: '20%' },
  content_structure:   { label: 'Content Structure',    icon: '📝', weight: '20%' },
  schema_markup:       { label: 'Schema Markup',        icon: '🏷️', weight: '15%' },
  factual_density:     { label: 'Factual Density',      icon: '📊', weight: '15%' },
  freshness:           { label: 'Freshness',            icon: '🕐', weight: '10%' },
  entity_clarity:      { label: 'Entity Clarity',       icon: '🏢', weight: '8%' },
  faq_alignment:       { label: 'FAQ Alignment',        icon: '❓', weight: '7%' },
  vocabulary_fluency:  { label: 'Vocabulary / Fluency',  icon: '✍️', weight: '5%' },
};

function barColor(score) {
  if (score >= 80) return 'var(--green)';
  if (score >= 60) return 'var(--cyan)';
  if (score >= 40) return 'var(--yellow)';
  if (score >= 20) return 'var(--orange)';
  return 'var(--red)';
}

export default function CategoryBar({ categoryKey, score }) {
  const meta = CATEGORY_META[categoryKey] || { label: categoryKey, icon: '📋', weight: '' };
  const color = barColor(score);

  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: '12px',
      padding: '10px 0', borderBottom: '1px solid var(--border)',
    }}>
      <span style={{ fontSize: '16px', width: '24px', textAlign: 'center' }}>{meta.icon}</span>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
          <span style={{ fontSize: '13px', fontWeight: 500, color: 'var(--text)' }}>{meta.label}</span>
          <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            <span style={{ fontSize: '11px', color: 'var(--text-muted)' }}>{meta.weight}</span>
            <span style={{ fontSize: '14px', fontWeight: 700, fontFamily: 'var(--mono)', color, minWidth: '32px', textAlign: 'left' }}>
              {score}
            </span>
          </div>
        </div>
        <div style={{ width: '100%', height: '6px', borderRadius: '3px', background: 'var(--border)', overflow: 'hidden' }}>
          <div style={{ width: Math.min(score, 100) + '%', height: '100%', borderRadius: '3px', background: color, transition: 'width 0.6s ease-out' }} />
        </div>
      </div>
    </div>
  );
}

export { CATEGORY_META };
